export const SET_LOGIN_USER = 'SET_LOGIN_USER';
export const SET_APPLICATIONS_BY_ID = 'SET_APPLICATIONS_BY_ID';
export const SET_ALERT_BOX = 'SET_ALERT_BOX';
export const CLEAR_ALERT_BOX = 'CLEAR_ALERT_BOX';
export const SET_REDIRECT = 'SET_REDIRECT';
export const SET_USERS_LIST = 'SET_USERS_LIST';
export const SET_OPEN_SIDEBAR = 'SET_OPEN_SIDEBAR';
export const SET_USERS_EDIT = 'SET_USERS_EDIT';
export const SET_MODAL_DELETE_USERS = 'SET_MODAL_DELETE_USERS';
export const SET_USERS_FOR_DELETE = 'SET_USERS_FOR_DELETE';
export const SET_ROLES_USER = 'SET_ROLES_USER';
export const SET_JOBS_USER = 'SET_JOBS_USER';
export const SET_ORGANIZATION_CREATED = 'SET_ORGANIZATION_CREATED';
export const SET_SEGMENTS_USER = 'SET_SEGMENTS_USER';
export const SET_SEGMENTS_EDIT = 'SET_SEGMENTS_EDIT';
export const CLEAR_USER_EDIT = 'CLEAR_USER_EDIT';
export const SET_USER_BY_ID = 'SET_USER_BY_ID';
export const SET_POST_USER_FIRST_STEP = 'SET_POST_USER_FIRST_STEP';
export const SET_NETWORKS_LIST = 'SET_NETWORKS_LIST';
export const SET_CLEAR_USER_FOR_EDIT = 'SET_CLEAR_USER_FOR_EDIT';
export const SET_UPDATE_PROFILE = 'SET_UPDATE_PROFILE';
